/**
 * scrolls smooth to the target.
 *
 * @param {number} distance - distance from top of DOM to the target element
 * @param {number} duration - duration of scroll effect in ms. Default value is 500
 * @return {undefined} - returns nothing
 */
const scrollToElement = (distance = 0, duration = 500) => {
  const scrollValue = window.scrollY ?? window.pageYOffset;
  const topToElm = scrollValue + distance;
  const baseY = (scrollValue + topToElm) * 0.5;
  const difference = scrollValue - baseY;
  let startTime = null;

  const animationStep = (timeStamp) => {
    startTime ??= timeStamp;
    let normalizedTime = (timeStamp - startTime) / duration;
    if (normalizedTime > 1) normalizedTime = 1;
    scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
    if (normalizedTime < 1) requestAnimationFrame(animationStep);
  };
  requestAnimationFrame(animationStep);
};

// we want only to set smooth scrolling in js for safari because the css property 'scroll-behaivor' is still not supported
if (!('scrollBehavior' in document.documentElement.style)) {
  // we need the timeout of 0 here to put this code to the end of the callstack, because some navigations are being rerendered after querySelector
  setTimeout(() => {
    const LINKS = document.querySelectorAll('.cm4all-theme-page-container a');
    for (const LINK of LINKS) {
      LINK.addEventListener('click', (_) => {
        if (!!_.target.hash) {
          const scrollPosition =
            document.querySelector(_.target.hash)?.getBoundingClientRect()
              .top ?? 0;
          scrollToElement(scrollPosition);
        }
      });
    }
  }, 0);
}
